import React from 'react'
import "./Navbar.css";
import petplazza_logo from "../images/petplazza_logo.jpg";

function Navbar() {
  return (
    <div>
      <div className='fixed-top'>

        <div className="petshopkrishnagar">
          <div className="album py-1">

            <div className="container">

              <div className="row ">

                <div className="col-md-6">
                  <div className="d-flex justify-content-between align-items-center">

                    <a style={{ color: "white" }} className="bethuaclothshop me-5" href="tel:  8927119640"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-minus" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                    </svg> 8927119640</a>
                    <a style={{ color: "white" }} href='UploadPrescription'>Upload Prescription <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-up" viewBox="0 0 16 16">
                      <path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707z" />
                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                    </svg></a>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center">

                </div>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-lg navbar-white bg-white shadow">
          <div className="container-fluid">

            <a className='petplazza' style={{ color: "#11006fff" }} href='/'>
              <img src={petplazza_logo} height="50px" width="74px" alt='petplazza_logo' />
              <b style={{ color: "#512c05" }}> PET PLAZZA</b>
            </a>



            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a className="nav-link active" aria-current="page" href="/">Home</a>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Services
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="vet-consultancy">Vet Consultancy</a></li>
                    <li><a className="dropdown-item" href="GroomingBook">Book For Grooming</a></li>
                    <li><a className="dropdown-item" href="StayBook">Book For Stay</a></li>



                  </ul>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="about-us">About Us</a>
                </li>



                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Products
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="dog-food">Dog Food</a></li>
                    <li><a className="dropdown-item" href="cat-food">Cat Food</a></li>
                    <li><a className="dropdown-item" href="healthproducts">Health Essentials</a></li>

                    <li><a className="dropdown-item" href="toys">Toys   </a></li>
                    <li><a className="dropdown-item" href="litter">Litter</a></li>
                    <li><a className="dropdown-item" href="grooming">Grooming</a></li>
                    <li><a className="dropdown-item" href="accessories">Accessories</a></li>
                    <li><a className="dropdown-item" href="Fashion">Fashion</a></li>
                    <li><a className="dropdown-item" href="PrescriptionDiet">Prescription Diet</a></li>
    


                  </ul>
                </li>
                  <li className="nav-item">
                  <a className="nav-link " href="our-outlet">Our Outlet</a>
                </li>
               
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Activity
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">

                    <li><a className="dropdown-item" href="photoGallery">Photo Gallery</a></li>
                    <li><a className="dropdown-item" href="VideoGallery">Video Gallery</a></li>


                  </ul>
                </li>
                <li className="nav-item">
                  <a className="nav-link me-3" href="contact-us">Contact us</a>
                </li>
              </ul>
              <a href='tel:  8927119640'>
                <button className="navbutton" type="submit">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                  </svg>+91  8927119640 <br />

                </button>
              </a>


            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Navbar